import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    addManualEntryApi,
    getManualEntryListApi,
    deleteManualEntryApi,
    getDeleteMessageManualApi,
    updateManualEntryApi,
    getUpdateManualEntryApi,
    getShiftTimingApi,
} from "./manualEntryApi";
import { showApiErrorToast, showApiSuccessToast } from "../../utils/toastErrorHandler";

const handleError = (err, rejectWithValue) => {
    if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
    }
    const errorMessage = err.response?.data?.message ||
        err.response?.data?.data ||
        err.message ||

        "Something went wrong"

    showApiErrorToast(errorMessage);
    return rejectWithValue(err.response?.data || { message: err.message });
};
export const addManualEntry = createAsyncThunk(
    "manualEntry/add",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addManualEntryApi(payload);
            showApiSuccessToast(response.data.message);
            return response ;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);
export const getUpdateManualEntry = createAsyncThunk(
    "manualEntry/getUpdate",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getUpdateManualEntryApi(payload);
            // showApiSuccessToast(response.data.message);
            return response
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);

export const updateManualEntry = createAsyncThunk(
    "manualEntry/update",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await updateManualEntryApi(payload);
            showApiSuccessToast(response.data.message);
            return response
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);
export const getManualEntryList = createAsyncThunk(
    "manualEntry/list",
    async (payload, { rejectWithValue }) => {
        try {
           const response = await getManualEntryListApi(payload);
            // showApiSuccessToast(response.data.message);
            return response
        } catch (err) {
            return handleError(err, rejectWithValue);
        }   
    }
);
export const getDeleteMessageManual = createAsyncThunk(
    "manualEntry/deleteMsg",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getDeleteMessageManualApi(payload);
            // showApiSuccessToast(response.data.message);
            return response;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);
export const deleteManualEntry = createAsyncThunk(
    "manualEntry/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteManualEntryApi(payload);
            showApiSuccessToast(response.data.message);
            return response
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);

export const getShiftTiming = createAsyncThunk(
    "manualEntry/getShiftTiming",
    async (shiftCode, { rejectWithValue }) => {
        try {
            const response = await getShiftTimingApi(shiftCode);
            return response;
        } catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);